import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import React from 'react'
import { Button, Col, Row } from 'reactstrap';

const TrackExceptionApproval = () => {
    const rowData = [
        { serialNumber: 1, employeeCode: '2324 ', position: 'PURCHASE HEAD', approverName: "TIKAM SINGH", approvalLevel: "Work Flow Process:-1", requestDate: "12/06/2023", action: "Pending", actionDate: "-" },
        { serialNumber: 1, employeeCode: '2324 ', position: 'PURCHASE HEAD', approverName: "TIKAM SINGH", approvalLevel: "Work Flow Process:-1", requestDate: "12/06/2023", action: "Pending", actionDate: "-" },

        // Add more rows as needed
    ];
    return (
        <div>
            <Row className={`filter-row-large`}>
                <Col md="12" className="mb-2">
                    <h1>Supplier Need List</h1>
                </Col>
            </Row>
            <Row className="ag-grid-react custom-pagination">
                <Col>
                    <div
                        className={`ag-grid-wrapper`}
                    >
                        <div
                            className={`ag-theme-material`}
                        >
                            <Row className={`filter-row-large`}>
                                <Col md="3" className="mb-2">
                                    <input
                                        type="text"
                                        className="form-control table-search"
                                        placeholder="Search"
                                        autoComplete={"off"}
                                    />
                                </Col>
                                <Col md="9" className="mb-3 d-flex justify-content-end">
                                    <div className="d-flex justify-content-end bd-highlight w100">
                                        <Button title="Add" className="mr5"><div className={"plus mr-0"}></div></Button>
                                        <button type="button" className={'user-btn mr5'} ><div className="download mr-1"></div> All</button>
                                        <button type="button" className="user-btn" title="Reset Grid"><div className="refresh mr-0"></div></button>
                                    </div>
                                </Col>
                            </Row>
                            <AgGridReact
                                style={{ height: "100%", width: "100%" }}
                                floatingFilter={true}
                                domLayout="autoHeight"
                                rowData={rowData}
                                rowSelection={"multiple"}
                                suppressRowClickSelection={true}
                                enableBrowserTooltips={true}
                                pagination={true}
                                pivotPanelShow={'always'}
                                paginationAutoPageSize={true}
                            >
                                <AgGridColumn
                                    // cellClass="has-checkbox"
                                    headerName="S. No."
                                    field="serialNumber"
                                    floatingFilter={false}
                                // sortable={false}
                                // valueGetter={(params) =>
                                //   currentRowIndex + params.node.rowIndex + 1
                                // }
                                // valueGetter={(params) => params.node.rowIndex + 1}
                                ></AgGridColumn>
                                <AgGridColumn
                                    cellClass="has-checkbox"
                                    field="categoryName"
                                    sortable={true}
                                    unSortIcon={true}
                                    filter={true}
                                    floatingFilter={true}
                                    headerName="Reason"
                                    comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                        valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                    }
                                // cellRenderer={checkBoxRenderer}
                                ></AgGridColumn>
                                <AgGridColumn
                                    field="vendorRequirementRegistrationId"
                                    filter={true}
                                    sortable={true}
                                    unSortIcon={true}
                                    floatingFilter={true}
                                    headerName="Employee Code"
                                    comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                        valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                    }
                                // cellRenderer={checkBoxRenderer}
                                ></AgGridColumn>

                                <AgGridColumn
                                    field="vendorRequirementRegistrationId"
                                    filter={true}
                                    sortable={true}
                                    unSortIcon={true}
                                    floatingFilter={true}
                                    headerName="Position"
                                    comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                        valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                    }
                                // cellRenderer={checkBoxRenderer}
                                ></AgGridColumn>

                                <AgGridColumn
                                    field="vendorRequirementRegistrationId"
                                    filter={true}
                                    sortable={true}
                                    unSortIcon={true}
                                    floatingFilter={true}
                                    headerName="Approver Name"
                                    comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                        valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                    }
                                // cellRenderer={checkBoxRenderer}
                                ></AgGridColumn>

                                <AgGridColumn
                                    field="vendorRequirementRegistrationId"
                                    filter={true}
                                    sortable={true}
                                    unSortIcon={true}
                                    floatingFilter={true}
                                    headerName="Expected Date of Correction"
                                    comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                        valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                    }
                                // cellRenderer={checkBoxRenderer}
                                ></AgGridColumn>
                                <AgGridColumn
                                    field="applyDate"
                                    headerName="Request Date"
                                    filter="agDateColumnFilter"
                                    valueFormatter={(params) => {
                                        if (params.value) {
                                            const date = new Date(params.value);
                                            // Check if the date is valid
                                            if (!isNaN(date.getTime())) {
                                                // If the date is valid, format it
                                                const day = date
                                                    .getDate()
                                                    .toString()
                                                    .padStart(2, "0");
                                                const month = (date.getMonth() + 1)
                                                    .toString()
                                                    .padStart(2, "0");
                                                const year = date.getFullYear();
                                                return `${day}/${month}/${year}`;
                                            } else {
                                                // If the date is invalid, return the original value
                                                return params.value;
                                            }
                                        } else {
                                            // If the value is null or undefined, return it as is
                                            return params.value;
                                        }
                                    }}
                                // floatingFilterComponentParams={{
                                //   : true, // Optional parameters for your custom filter component
                                //   // Add any other parameters you want to pass to your custom filter component
                                // }}
                                ></AgGridColumn>
                                <AgGridColumn
                                    field="vendorRequirementRegistrationId"
                                    filter={true}
                                    sortable={true}
                                    unSortIcon={true}
                                    floatingFilter={true}
                                    headerName="Sent Remark"
                                    comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                        valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                    }
                                // cellRenderer={checkBoxRenderer}
                                ></AgGridColumn>
                                <AgGridColumn
                                    field="vendorRequirementRegistrationId"
                                    filter={true}
                                    sortable={true}
                                    unSortIcon={true}
                                    floatingFilter={true}
                                    headerName="Approval Status"
                                    comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                        valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                    }
                                // cellRenderer={checkBoxRenderer}
                                ></AgGridColumn>
                                <AgGridColumn
                                    field="vendorRequirementRegistrationId"
                                    filter={true}
                                    sortable={true}
                                    unSortIcon={true}
                                    floatingFilter={true}
                                    headerName="Received Remark"
                                    comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                        valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                    }
                                // cellRenderer={checkBoxRenderer}
                                ></AgGridColumn>
                            </AgGridReact>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default TrackExceptionApproval;
